// extracted by mini-css-extract-plugin
export default {"resultsHeader":"ResultsBar_resultsHeader__Y6XDg","resultsList":"ResultsBar_resultsList__oklua"};